import { Text } from "./Text"
import { TextVariant } from "@/theme"
import clsx from "clsx"
import Link from "next/link"

export const TextLink: React.FC<{
  text: string
  variant?: TextVariant
  underline?: boolean
  size?: "small" | "medium" | "large"
  className?: string
  href?: string
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  RightIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>> | undefined
  LeftIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>> | undefined
  colorVariant?: "gray" | "solid"
}> = ({
  text,
  RightIcon,
  LeftIcon,
  underline,
  variant = "CTASmall",
  className,
  onClick,
  href,
  colorVariant = "gray",
}) => {
  const isGray = colorVariant === "gray"

  const content = (
    <div
      className={clsx("group flex flex-row items-center gap-2", Boolean(onClick) && "cursor-pointer", className)}
      onClick={onClick}>
      {LeftIcon && (
        <LeftIcon
          height={22}
          width={22}
          className={clsx(
            "flex flex-shrink-0",
            isGray ? "stroke-fg-2 group-hover:stroke-fg-1" : "stroke-fg-1 group-hover:stroke-fg-2"
          )}
        />
      )}
      <Text
        variant={variant}
        className={clsx(
          isGray ? "text-fg-2 group-hover:text-fg-1" : "text-fg-1 group-hover:text-fg-2",
          underline && "underline"
        )}>
        {text}
      </Text>
      {RightIcon && (
        <RightIcon
          height={22}
          width={22}
          className={clsx(
            "flex flex-shrink-0",
            isGray ? "stroke-fg-2 group-hover:stroke-fg-1" : "stroke-fg-1 group-hover:stroke-fg-2"
          )}
        />
      )}
    </div>
  )

  if (href) {
    return (
      <Link href={href} className={clsx("group", className)}>
        {content}
      </Link>
    )
  }

  return content
}
